module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxwYXRoIGQ9Ik0xLjMzMjkgOC45MjAxNGUtMDZMMCAxLjMzMjkxTDUuNjY3NTcgN0wzLjE2NTIxZS0wNiAxMi42Njc2TDEuMzMyOSAxNEw3IDguMzMyOUwxMi42Njc2IDE0TDE0IDEyLjY2NzFMOC4zMzI5IDdMMTQgMS4zMzI5TDEyLjY2NzYgMEw3IDUuNjY3MDlMMS4zMzI5IDguOTIwMTRlLTA2WiIgZmlsbD0id2hpdGUiLz4NCjwvc3ZnPg0K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/times-white.svg
// module id = FGLg
// module chunks = 1